import { Button, Typography } from '@material-ui/core';
import React from 'react';
import { useIntl } from 'react-intl';
import messages from 'src/components/notifications/messages';

export const CALENDLY_LINK = "https://calendly.com/milan-sundac/myfitworld-introduction-clone-3";

function ButtonScheduleConsultation({ isLoading }: { isLoading?: boolean }) {
  const { formatMessage } = useIntl();
  return (
    <Button
      color="primary"
      variant="outlined"
      style={{ marginTop: 10 }}
      disabled={isLoading}
      onClick={() => {
        window.open(CALENDLY_LINK, '_blank');
      }}
    >
      <Typography  color="primary">
        {formatMessage(messages.click_here)}&nbsp;
      </Typography>

      <Typography style={{textTransform: 'lowercase' }}>
        {formatMessage(messages.schedule_free_consultations)}
      </Typography>
    </Button>
  );
}

export default ButtonScheduleConsultation;
